import React, { useEffect, useState } from "react";
import TimesheetManagementPage from "../../../../entities/DashboardPage/HRModule/TimesheetManagementPage";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";
import moment from "moment-timezone";

const TimesheetManagement = () => {
  const [data, setData] = useState();
  const { showAlert } = useAlert();
  const [projectList, setProjectList] = useState();
  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState();
  const [open, setOpen] = useState(false);
  const [clear, setClear] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [depData, setDepData] = useState([])
  const [empData, setempData] = useState([])
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const [departmentData, setDepartmentData] = useState([])

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getTimesheetList("", "", page);
      getProjectList();
    }
  }, [page, permission])

  useEffect(() => {
    getDepartment();
    getAllDepartmentList();
  }, [])

  const getTimesheetList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getTimesheetList(text, sort, page);
      if (result?.success) {
        let timesheets = result?.data?.timesheet || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.timesheet?.isView === true;
          const hasEditPermission = permission?.timesheet?.isEdit === true;
          
          // If employee has edit permission, show all timesheets (like admin)
          if (hasEditPermission) {
            setTotal(result?.data?.totalCount);
          } else if (hasViewPermission) {
            // If only view permission, show only own data
            timesheets = timesheets.filter((ts) => ts?.employee?._id === employeeId || ts?.employee?.userId === employeeId);
            setTotal(timesheets.length);
          } else {
            // No view permission, show nothing
            timesheets = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.totalCount);
        }
        
        setClear(!clear);
        setData(timesheets);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleTimesheetRequest = async (id, request, isPaid) => {
    setLoading(true);
    try {
      const result = await AuthService.handleTimesheetRequest(id, request, isPaid);
      if (result?.success) {
        setLoading(false);
        showAlert(result?.message, "success")
        setOpen(false);
        getTimesheetList();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getProjectList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getProjectList();
      if (result?.success) {
        setProjectList(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleTimesheet = async (project, date, desc, id) => {
    setLoading(true);
    try {
      const result = await AuthService.handleTimesheet(project, date, desc, id);
      if (result?.success) {
        setClear(true);
        showAlert(result?.message, "success")
        setLoading(false);
        setOpen(false);
        getTimesheetList();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
    setClear(false)
  };

  const postTimesheet = async (project, date, desc, id) => {
    setLoading(true);
    const timeZone = moment.tz.guess();
    try {
      const result = await AuthService.postTimesheet(project, date, desc, timeZone, id);
      if (result?.success) {
        setClear(true);
        showAlert(result?.message, "success")
        setLoading(false);
        setOpen(false);
        getTimesheetList();
      } else {
        showAlert(result?.message, "error")
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const SearchEmployee = async (text) => {
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDeleteEmployee = async (text) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteTimesheet(text);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        getTimesheetList()
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const DepartmentPayroll = async (department) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handlePayrollDepartmemt(department);
      if (result?.success) {
        setDepData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getAllDepartmentList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllDepartmentList();
      if (result?.success) {
        setempData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  return (
    <>
      <TimesheetManagementPage getTimesheetList={getTimesheetList} empData={empData} depData={depData} DepartmentPayroll={DepartmentPayroll}
        departmentData={departmentData} clear={clear} setClear={setClear} permission={permission} role={role} open={open} setOpen={setOpen}
        handleTimesheetRequest={handleTimesheetRequest} data={data} handleSort={(sort) => getTimesheetList("", sort)} postTimesheet={postTimesheet}
        loading={loading} projectList={projectList} handleDeleteEmployee={handleDeleteEmployee} handleTimesheet={handleTimesheet} SearchEmployee={SearchEmployee}
        employeeData={employeeData} page={page} total={total} setPage={setPage} handleFilter={getTimesheetList} />
    </>
  )

}

export default TimesheetManagement;
